import React, { useEffect, FC, useContext } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
// selectors
import { useConfigSelectors } from 'src/@app/reducers/configReducer';
import { useSortSelectors, useFilterSelectors } from 'src/@operations/reducers';
import { OperationDispatchContext } from 'src/@operations/providers/OperationsStateProvider';
// actions
import { initialiseFilterStore, resetAndFetchData, fetchData } from 'src/@operations/actions';
// stores
import { dateRangeStore } from 'src/@app/stores/dateRangeStore';
// utils
import { screenScrollToTop } from 'src/utils';
import { IDataContainer } from 'src/@operations/props';
import { convertDataToFilterForm } from 'src/@operations/functions';

export const DataContainer: FC<IDataContainer> = ({ children }) => {
  const client = useApolloClient();
  const dispatcher = useContext(OperationDispatchContext);
  // Configuration
  const configSelectors = useConfigSelectors();
  const {
    grid: { resultSize },
  } = configSelectors.getConfig();
  const initialFilters = configSelectors.getOperationFilterSet();
  const sortSelectors = useSortSelectors();
  const filterSelectors = useFilterSelectors();
  const filterString = filterSelectors.getFilterString();
  const isInitialised = filterSelectors.getIfInitialised();
  const sortString = sortSelectors.getSortString();
  const { from, to } = dateRangeStore.getDatesStrings();

  useEffect(() => {
    if (isInitialised) {
      resetAndFetchData(client, resultSize, dispatcher, sortString, filterString);
    }
  }, [filterString, sortString, from, to]);

  useEffect(() => {
    screenScrollToTop();
  }, []);

  useEffect(() => {
    if (isInitialised) {
      fetchData(client, resultSize, dispatcher, sortString, filterString);
    } else {
      const convertedFilterData = {};
      Object.entries(initialFilters).map(([key, value]) => {
        let iconType = '';
        if (key === 'aircraftCategories') {
          iconType = 'ac';
        }
        if (key === 'operationTypes') {
          iconType = 'ad';
        }
        if (key === 'correlated') {
          iconType = 'co';
        }

        convertedFilterData[key] = convertDataToFilterForm(value, iconType);
      });

      initialiseFilterStore(dispatcher, convertedFilterData);
    }
  }, [isInitialised]);

  return <>{children}</>;
};
